import { useSiteStore } from '~/stores/site'

export default defineNuxtPlugin({
  name: 'site-config-realtime',
  dependsOn: ['pinia'],
  setup(nuxtApp) {
    if (process.server) return

    nuxtApp.hooks.hook('app:mounted', async () => {
      // Wait a bit for stores to be ready
      await new Promise(resolve => setTimeout(resolve, 100))
      
      let siteStore, route
      try {
        siteStore = useSiteStore()
        route = useRoute()
      } catch (error) {
        console.error('[SiteConfigRealtime] Error accessing stores:', error)
        return
      }

      const getDealershipId = async () => {
        
        // Try route params first (for CMS pages ONLY - not vehicle detail pages)
        if (route.params.id && typeof route.params.id === 'string' && route.path.includes('/cms/')) {
          return route.params.id
        }
        
        // Try store dealershipId
        if ((siteStore as any).dealershipId) {
          return (siteStore as any).dealershipId
        }
        
        // Try to get it from the _dealership_id field in the config
        if ((siteStore as any)._dealership_id) {
          return (siteStore as any)._dealership_id
        }
        
        // If not available, try to fetch the site config to get the dealership ID
        try {
          const config = await $fetch('/api/site-config', {
            query: { _refresh: Date.now() }
          })
          if (config && config._dealership_id) {
            return config._dealership_id
          }
        } catch (e) {
          console.warn('[SiteConfigRealtime] Failed to fetch config for dealership ID:', e)
        }
        
        return null
      }

      try {
        const supabase = useSupabaseClient()
        if (!supabase) return

        const dealershipId = await getDealershipId()
        
        const channel = supabase
          .channel('site-config-updates')
          .on('postgres_changes', {
            event: '*',
            schema: 'public',
            table: 'site_config_updates',
            ...(dealershipId ? { filter: `dealership_id=eq.${dealershipId}` } : {})
          }, async (payload) => {
            // When an update is published, refetch config and patch store
            try {
              // Add a small delay to allow CDN cache to clear
              await new Promise(resolve => setTimeout(resolve, 500))
              
              const fresh = await $fetch('/api/site-config', {
                query: {
                  _refresh: Date.now(),
                  _cb: Math.random().toString(36).substr(2, 9),
                  ...(dealershipId ? { dealership_id: dealershipId } : {})
                },
                headers: {
                  'Cache-Control': 'no-cache, no-store, must-revalidate',
                  'Pragma': 'no-cache'
                }
              })
              if (fresh) {
                siteStore.$patch(fresh)
              }
            } catch (e) {
              console.warn('[SiteConfigRealtime] Refresh after update failed:', e)
            }
          })
          .subscribe()

        // Cleanup
        if (typeof window !== 'undefined') {
          window.addEventListener('beforeunload', () => {
            channel.unsubscribe()
          })
        }
      } catch (e) {
        console.warn('[SiteConfigRealtime] Initialization failed:', e)
      }
    })
  }
})


